//service
import http from "./httpService";
import config from "./config"



export const journals = () => {
    return http.get(
        `${config.apiAddress}journals/`,
    );
};


export const journal = slug => {
    return http.get(
        `${config.apiAddress}journals/${slug}`
    );
};





export const conferences = () => {
    return http.get(
        `${config.apiAddress}conferences/`,
    );
};

export const conference = slug => {
    return http.get(
        `${config.apiAddress}conferences/${slug}`
    );
};



export const books = () => {
    return http.get(
        `${config.apiAddress}books/`,
    );
};

export const book = slug => {
    return http.get(
        `${config.apiAddress}books/${slug}`
    );
};
